<h1>
  <a class="home-non-link">
    <i class="fa fa-home" aria-hidden="true"></i>
    {{'Contact person' | translate}}
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="getLoading()" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>

  <div class="container-content" fxLayout fxLayoutAlign="space-between start">
    <form [formGroup]="getContactPersonForm()" fxLayout="column" fxFlex novalidate class="ng">

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="title" class="control-label" fxFlex="30">
          {{'Title' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border"
            name="title" id="title"
            formControlName="title">
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="firstName" class="control-label" fxFlex="30">
          {{'First name' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border"
            name="firstName" id="firstName"
            formControlName="firstName">
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="lastName" class="control-label" fxFlex="30">
          {{'Last name' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border"
            name="lastName" id="lastName"
            formControlName="lastName">
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="phone" class="control-label" fxFlex="30">
          {{'Email address' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="email"
            class="form-control form-control-border"
            name="email" id="email"
            formControlName="email">
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="phone" class="control-label" fxFlex="30">
          {{'Phone number' | translate}}
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border"
            name="phone" id="phone"
            formControlName="phone">
        </div>
      </div>

    </form>

  </div>
</div>
